export const PAYPAL_IDENTITY = "PAYPAL_IDETITY";

export default (state = null, action) => {
    switch (action.type) {
        case PAYPAL_IDENTITY:
            return action.payload;
        default:
            return state;
    }
}
